import web from '../src/images/i1.jpg';
import bhoot from '../src/images/i2.jpg';
import apple from '../src/images/i3.jpg';
import mango from '../src/images/i4.jpg';
import bolly from '../src/images/i5.jpg';
import wood from '../src/images/i6.jpg';


const sData=[
    {
        imgSrc:web,
        name:"Card Title1"
    },
    {
        imgSrc:bhoot,
        name:"Card Title2"
    },
    {
        imgSrc:apple,
        name:"Card Title3"
    },
    {
        imgSrc:mango,
        name:"Card Title4"
    },
    {
        imgSrc:bolly,
        name:"Card Title5"
    },
    {
        imgSrc:wood,
        name:"Card Title6"
    },
    
];

export default sData;

